import { Loading } from 'element-ui';
import { downloadFiles } from './file.js';
export * from './file.js';
export * from './validation.js';

/**
 * 获取公司列表
 * @param {Object} vue Vue实例
 * @param {string} type 请求参数 0.施工单位,1.材料供应商,2.机械供应商,3.劳务公司,4.咨询公司,5.其他咨询公司
 * @returns {Promise} 返回格式化后的公司列表
 */
export function getPriseList(vue, type) {
  return new Promise((resolve) => {
    vue.$request.post('/collective/select/priseList', { type: type }).then((res) => {
      resolve(res);
    });
  });
}

/**
 * 获取合同列表
 * @param {Object} vue Vue实例
 * @param {string} type 请求参数 类型 1.材料 2.机械 3.劳务4.其他
 * @returns {Promise} 返回格式化后的公司列表
 */
export function getContractList(vue, type) {
  return new Promise((resolve) => {
    vue.$request.post('/collective/select/contractList', { type: type }).then((res) => {
      resolve(res);
    });
  });
}

/**
 * 列表导出
 * @param {Object} vue Vue实例
 * @param {string} url 请求参数 接口地址
 * @param {string} data 请求参数 参数
 */
export function exportList(vue, url, data) {
  return new Promise((resolve) => {
    const loadingInstance = Loading.service({
      lock: true,
      text: '正在导出中，请稍后...',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.7)',
    });
    vue.$request
      .post(url, data)
      .then((res) => {
        downloadFiles(res);
        // vue.$message.success('下载成功')
        resolve(res);
      })
      .finally(() => {
        loadingInstance.close();
      });
  });
}

/**
 * 金额超过三位数的以逗号分隔显示
 * @param {string} number 金额
 * @param {string} n 保留n位小数
 * @param {boolean} autoTrim 是否自动处理小数点后的0，默认为false
 * @returns {boolean} 结果
 */
export function formatCurrency(number, n = 2, autoTrim = false) {
  number = number ? parseFloat(number) : 0;
  if (isNaN(number) || number === 0) return number.toString();
  let formattedNumber = number.toFixed(n).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');

  if (autoTrim) {
    formattedNumber = formattedNumber.replace(/\.?0+$/, '');
  }

  return formattedNumber;
}

/**
 * 获取环境选择列表
 * @param {Object} vue Vue实例
 * @param {Array} key 请求参数 settlement_modes结算方式,experience工作经历,education学历要求,
 * wage薪资,age年龄,position_attribu求职类型,sex性别,job_status在职状态,person_number班组人数,
 * sales_method售卖方式,star_rating星级,price价格,speciality专业,qualifications资质等级
 * @returns {Promise} 返回格式化后的公司列表
 */
export function getConditionList(vue, key) {
  return new Promise((resolve) => {
    vue.$request.post('/collective/select/conditionList', { key: key }).then((res) => {
      resolve(res);
    });
  });
}

/**
 * 获取指定位置的广告信息
 * @param {number} id - 广告位置ID
 * @returns {Promise} 返回一个Promise对象，解析后获取广告数据数组
 */
export function getFrontAd(vue, id) {
  return new Promise((resolve) => {
    vue.$request.post('/collective/select/getbananerlist', { position_id: id }).then((res) => {
      resolve(res || []);
    });
  });
}

/**
 * 校验权限
 * @param {string} code 权限码
 * @returns {boolean} 结果
 * */
export function checkPermission(code) {
  if (!code) return true;
  const authList = JSON.parse(sessionStorage.getItem('rule') || []);
  if (!authList.length) return true;
  return authList.find((item) => item == code) !== undefined;
}

/**
 * 根据角色校验不同权限
 * @param {string} navs 角色
 * @param {string} code1 材料供应商权限码
 * @param {string} code2 机械供应商权限码
 * @param {string} code3 施工单位权限码
 * @param {string} code4 其他公司权限码
 * @returns {boolean} 结果
 * */
export function checkRolePermission(navs, code1, code2) {
  const code = navs == '材料供应商' ? code1 : navs == '机械供应商' ? code2 : '';
  if (!code) return true;
  return checkPermission(code);
}

/**
 * 节流
 * @param {function} fn 方法
 * @returns {Number} delay 延迟
 * */
export function throttle(fn, delay) {
  let timeout;
  return function (...args) {
    const context = this;
    if (!timeout) {
      fn.apply(context, args);
      timeout = setTimeout(() => {
        timeout = null;
      }, delay || 1000);
    }
  };
}

/**
 * 转换数字为以“万”为单位的值
 * @param {number|string} value 输入值
 * @returns {number|string} 转换后的值或原值
 */
export function convertToWan(value) {
  if (typeof value !== 'number' && isNaN(value)) return value;
  value = parseFloat(value);
  if (value >= 10000) {
    return (value / 10000).toFixed(2) + '万';
  }
  return value;
}
